import { useCurrentUser } from "../../../../AuthWrapper2/hooks/useCurrentUser.js";
import "react";
import { Button, ColorCircle, Select } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { getColorContrast } from "@therms/web-js";
//#region src/modules/Events/shared/EventInteractive/components/EventUserAssignmentStatusPicker.tsx
function EventUserAssignmentStatusPicker({ assignedUser, loading, onUpdateAssignedUserStatus, options }) {
	const { id } = useCurrentUser();
	if (assignedUser.userId === id) return /* @__PURE__ */ jsx("div", {
		className: "gap-sm inline-flex flex-wrap",
		children: options.map((option) => {
			const dimmed = option.abbreviation === assignedUser.status?.abbreviation || loading;
			return /* @__PURE__ */ jsx(Button, {
				className: dimmed ? "opacity-30" : "",
				disabled: dimmed,
				onClick: () => onUpdateAssignedUserStatus(assignedUser.userId, option),
				style: option.color ? {
					backgroundColor: option.color,
					color: getColorContrast(option.color),
					opacity: dimmed ? .25 : 1
				} : {},
				children: option.abbreviation
			}, `${option.title}/${option.abbreviation}`);
		})
	});
	return /* @__PURE__ */ jsx(Select, {
		disabled: loading,
		isLoading: loading,
		isSearchable: false,
		options,
		optionValueExtractor: (option) => option,
		onChangeOptions: (option) => onUpdateAssignedUserStatus(assignedUser.userId, option),
		RenderSelectedSingle: (option) => /* @__PURE__ */ jsxs("div", {
			className: "gap-x-sm inline-flex",
			children: [
				/* @__PURE__ */ jsxs("div", { children: [option.color && /* @__PURE__ */ jsx(ColorCircle, { color: option.color }), " "] }),
				/* @__PURE__ */ jsx("span", { children: option.abbreviation }),
				/* @__PURE__ */ jsx("span", { children: option.title })
			]
		}),
		RenderListItem: (option) => /* @__PURE__ */ jsxs("div", {
			className: "gap-x-sm inline-flex",
			children: [
				/* @__PURE__ */ jsxs("div", { children: [option.color && /* @__PURE__ */ jsx(ColorCircle, { color: option.color }), " "] }),
				/* @__PURE__ */ jsx("span", { children: option.abbreviation }),
				/* @__PURE__ */ jsx("span", { children: option.title })
			]
		}),
		value: assignedUser.status
	});
}
//#endregion
export { EventUserAssignmentStatusPicker };

//# sourceMappingURL=EventUserAssignmentStatusPicker.js.map